var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.775 1.2342C12.4175 0.876701 11.84 0.876701 11.4825 1.2342L7 5.70753L2.5175 1.22503C2.16 0.867534 1.5825 0.867534 1.225 1.22503C0.867504 1.58253 0.867504 2.16003 1.225 2.51753L5.7075 7.00003L1.225 11.4825C0.867504 11.84 0.867504 12.4175 1.225 12.775C1.5825 13.1325 2.16 13.1325 2.5175 12.775L7 8.29253L11.4825 12.775C11.84 13.1325 12.4175 13.1325 12.775 12.775C13.1325 12.4175 13.1325 11.84 12.775 11.4825L8.2925 7.00003L12.775 2.51753C13.1233 2.1692 13.1233 1.58253 12.775 1.2342Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedCloseIcon);
export default __webpack_public_path__ + "static/media/DeprecatedCloseIcon.ef03ffbdc34acafe244d0ea19dadca6f.svg";
export { ForwardRef as ReactComponent };